<template>
  <a-form-model-item :label="field.label" :label-col="fieldLabelCol" :wrapper-col="fieldWrapperCol">
    <!-- 名称/ID -->
    <a-input v-if="field.key === 'name'" :value="form.name" allow-clear placeholder="任务名称/ID" @change="handleInputChange('name', $event)" />
    <!-- 状态 -->
    <a-select v-else-if="field.key === 'status'" :value="form.status" mode="multiple" allow-clear placeholder="任务状态" @change="handleSelectChange('status', $event)">
      <a-select-option v-for="(item, index) in options.statusList" :key="index" :value="item.value">
        <a-badge :status="item.status" :color="item.color" :text="item.label" />
      </a-select-option>
    </a-select>
    <!-- 处理人 -->
    <user-select v-else-if="field.key === 'handlers'" :value="form.handlers" mode="multiple" allow-clear show-search show-all placeholder="任务处理人" :project-id="projectId" @change="handleSelectChange('handlers', $event)" />
    <!-- 创建人 -->
    <user-select v-else-if="field.key === 'creator'" :value="form.creator" allow-clear show-search show-all placeholder="任务创建人" :project-id="projectId" @change="handleSelectChange('creator', $event)" />
    <!-- 与我相关 -->
    <a-radio-group v-else-if="field.key === 'about'" :value="form.about" button-style="solid" @change="handleInputChange('about', $event)">
      <a-radio-button value="all">全部</a-radio-button>
      <a-radio-button value="about">与我相关</a-radio-button>
    </a-radio-group>
    <!-- 时间筛选 -->
    <a-input-group v-else-if="field.key === 'dateRange'" compact>
      <a-select :value="form.time_filter_key" style="width: 30%" @change="handleSelectChange('time_filter_key', $event)">
        <a-select-option value="pre_time">计划时间</a-select-option>
        <a-select-option value="real_time">实际时间</a-select-option>
        <a-select-option value="created_time">创建时间</a-select-option>
        <a-select-option value="completed_time">完成时间</a-select-option>
      </a-select>
      <a-date-picker :value="form.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleDateChange('start_time', $event)" />
      <a-date-picker :value="form.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleDateChange('end_time', $event)" />
    </a-input-group>
  </a-form-model-item>
</template>

<script>
import { storySearch } from '@/api/project/story';
import { versionList } from '@/api/project/version';
import { projectList } from '@/api/project/project';

import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'TaskFilterFormItem',
  components: { UserSelect },
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        statusList: [],
        tagData: [],
        objectiveData: [
          { key: 1, value: 1, disabled: true, title: '编码任务', children: [] },
          { key: 2, disabled: true, value: 2, title: '非编码任务', children: [] }
        ]
      })
    },
    projectId: {
      type: Number,
      default: 0
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      searching: false,
      requirementValue: [],
      versionData: [],
      projectData: [],
      searchStoryData: [],
      storySearching: false
    };
  },
  computed: {
    fieldLabelCol() {
      return this.labelCol === null ? { span: this.field.labelSpan || 6 } : this.labelCol;
    },
    fieldWrapperCol() {
      return this.wrapperCol === null ? { span: this.field.wrapperSpan || 18 } : this.wrapperCol;
    }
  },
  methods: {
    handleInputChange(key, event) {
      this.$emit('change', { key, value: event.target.value });
    },

    handleSelectChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleDateChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleStoryChange(value) {
      this.requirementValue = value;
      if (value) {
        this.$emit('change', { key: 'requirement_ids', value: value.map(item => item.key) });
      } else {
        this.$emit('change', { key: 'requirement_ids', value: [] });
      }
    },

    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },

    searchStory(value) {
      this.searching = true;
      const filter = { value };
      if (this.projectId > 0) {
        filter.project_id = this.projectId;
      }
      storySearch(filter)
        .then(res => {
          this.searchStoryData = res.data.items;
          this.searching = false;
        })
        .catch(() => {
          this.searching = false;
        });
    },

    getProjectData() {
      projectList({ page_index: 1, page_size: 100 }).then(res => {
        this.projectData = res.data.projects;
      });
    },

    getVersionData(value) {
      this.searching = true;
      const filter = { title: value };
      versionList({ ...filter, project_id: this.projectId, page_index: 1, page_size: 20 })
        .then(res => {
          this.searching = false;
          this.versionData = res.data.list;
        })
        .catch(() => {
          this.searching = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 0px;

  .ant-form-item-label {
    text-align: right;
    color: #495057;
    padding-right: 8px;
  }
}

:deep(.ant-input),
:deep(.ant-select),
:deep(.ant-picker),
:deep(.ant-tree-select),
:deep(.ant-calendar-picker) {
  width: 100%;
}
</style>
